import { render, staticRenderFns } from "./FamilyRegistration.vue?vue&type=template&id=5e6dc141&scoped=true"
import script from "./FamilyRegistration.vue?vue&type=script&lang=js"
export * from "./FamilyRegistration.vue?vue&type=script&lang=js"
import style0 from "./FamilyRegistration.vue?vue&type=style&index=0&id=5e6dc141&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6dc141",
  null
  
)

export default component.exports